<template>
  <div class="pad30" v-if="loaded">
    <h2 class="f18 fb normal gray_2">价格方案</h2>
    <div class="box20"></div>
    <p class="ps_main_head">温馨提示：客户个人和客户所在分组均被设置价格方案时，优先以客户个人设置的价格方案金额为准</p>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <label>方案名称：</label>
        <el-input class="w150 mar20_r" placeholder="请输入价格方案名称" v-model.trim="name"></el-input>
      </div>
      <div>
        <label>客户名称：</label>
        <el-input class="w150 mar20_r" placeholder="请输入客户名称" v-model.trim="customerName"></el-input>
      </div>
      <div>
        <label>客户电话：</label>
        <el-input class="w150 mar20_r" placeholder="请输入客户电话" v-model.trim="customerPhone"></el-input>
      </div>
      <div>
        <label>商品信息：</label>
        <el-input class="w150 mar20_r" placeholder="请输入商品名称" v-model.trim="goodsName"></el-input>
      </div>
      <el-button @click="getSchemeList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="addScheme">添加</el-button>

      <el-button type="primary" class="mar-15-l" @click="batchUpdate">批量调价</el-button>

      <el-button type="primary" class="mar-15-l" @click="exportDtl">导出</el-button>
    </div>
    <el-table :data="schemeList" @selection-change="customerSelect" row-key="targetId" style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="名称" />
      <el-table-column prop="schemeTypeCn" label="类别" />
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button @click="editScheme(scope.row)">编辑</el-button>
          <el-button class="mar15-l" @click="deleteScheme(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" :disabled="this.multipleSelection.length == 0" @click="deleteSchemeList">批量删除 </el-button>
      <div class="gray9 flex-auto mar-20-l">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[10, 20, 30]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
  <div style="min-height: 900px" v-else></div>
</template>

<script>
import { mapState } from "vuex";
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      loaded: false,
      env: process.env,
      schemeList: [],
      multipleSelection: [],
      // 搜索
      customerName: "",
      customerPhone: "",
      goodsName: "",
      name: "",
      pageSize: 10,
      pageNum: 1,
      totalPage: 10,
      pageTotal: 0,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getSchemeList();
  },
  methods: {
    openWindow(title, url) {
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: url,
              title: title,
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(url);
      }
    },
    addScheme() {
      window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme?appid=1&isShowTitle=1`;
    },
    editScheme(row) {
      let id = row.id;
      window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme?appid=1&isShowTitle=1&id=` + id;
    },
    batchUpdate() {
      window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme/batchUpdate?appid=1&isShowTitle=1`;
    },
    getSchemeList() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/selList`, {
          customerName: this.customerName,
          customerPhone: this.customerPhone,
          goodsName: this.goodsName,
          name: this.name,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        })
        .then((res) => {
          this.pageTotal = res.data.total;
          this.schemeList = res.data.list;
          this.totalPage = res.data.pages;
          this.loaded = true;
          loadingInstance1.close();
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getSchemeList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getSchemeList();
    },

    customerSelect(val) {
      console.log("val", val);
      this.multipleSelection = val || [];
    },
    deleteScheme(item) {
      let idList = [];
      idList.push(item.id);
      this.$confirm("您是否要删除当前所选价格方案:" + item.name, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/delBatch`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getSchemeList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    deleteSchemeList() {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请选择方案");
        return;
      }
      let idList = [];
      let nameList = [];
      this.multipleSelection.forEach(function (item) {
        idList.push(item.id);
        nameList.push(item.name);
      });
      this.$confirm("您是否要删除当前所选客户：" + nameList.toString(), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/delBatch`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getSchemeList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    exportDtl() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/export`, {
          customerName: this.customerName,
          customerPhone: this.customerPhone,
          goodsName: this.goodsName,
          name: this.name,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        })
        .then((res) => {
          loadingInstance1.close();
          if (res.code !== 0 && res.code !== "0") {
            this.$message.warning(res.msg);
            return;
          }
          if (!res.data || !res.data.url) {
            this.$message.error("导出价格方案为空");
            return;
          }
          window.open(res.data.url);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>

<style>
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}

.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}

.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-select-dropdown__item.selected {
  color: #0095f1;
  font-weight: bold;
}
.ps_main_head {
  color: #999;
  background-color: #f8f8f8;
  padding-left: 30px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-size: 12px;
}
</style>
